import { PaymentPlanCodes } from '../../price-plan/enums';
import { SubscriptionTypes } from '../../restaurant/enums';
import { LocationRecurly } from '../../restaurant/models';
import { FreePlanSubscriptionStates } from '../../recurly/constants';

export function isOnFreePlan(user: FreePlanUser): boolean {
  return user.account.subscriptionType === SubscriptionTypes.recurly
    && (user.location.recurly?.planCode === PaymentPlanCodes.Free
      || FreePlanSubscriptionStates.includes(user.location.recurly?.subscription_state));
}

export const ERROR_FREE_PLAN_NOT_AVAILABLE = 'ERROR_PLATFORM_AVAILABILITY';

export interface FreePlanUser {
  account?: {
    subscriptionType: SubscriptionTypes;
  };
  location?: {
    recurly: LocationRecurly;
  };
}
